import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { UnavailableInLens } from '@infl-ts/ui-advocate-components';
import { logQueryError } from '@infl-ts/util-query-errors';
import * as DE from '@nll/datum/lib/DatumEither';
import { constant, flow, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as Str from 'fp-ts/string';
import { useCallback, useEffect, useState } from 'react';
import CommentsList, { FocusedCommentsList } from './comments-list';
import ReplyInput from './reply-input';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultResult = {
  edges: [],
  pageInfo: {
    hasNextPage: false,
    endCursor: '0'
  },
  totalCount: 0
};

var useTrackNewComment = function useTrackNewComment() {
  var _useState = useState(null),
      newComment = _useState[0],
      setNewComment = _useState[1];

  var setAsOld = useCallback(function () {
    return setNewComment(null);
  }, [setNewComment]);
  useEffect(function () {
    if (newComment !== null) {
      var timer = setTimeout(setAsOld, 800);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [newComment, setAsOld]);
  return {
    newComment: O.fromNullable(newComment),
    setNewComment: setNewComment
  };
};

var CommentsSection = function CommentsSection(_ref) {
  var publicResponseId = _ref.publicResponseId,
      _ref$handleComments = _ref.handleComments,
      comments = _ref$handleComments.comments,
      _handleFetchMoreComments = _ref$handleComments.handleFetchMoreComments,
      hiddenFromMembers = _ref.hiddenFromMembers,
      totalCount = _ref.totalCount,
      profile = _ref.profile,
      handleHideComments = _ref.handleHideComments,
      replyInputRef = _ref.replyInputRef,
      useScrollToFocused = _ref.useScrollToFocused;

  var _useTrackNewComment = useTrackNewComment(),
      newComment = _useTrackNewComment.newComment,
      setNewComment = _useTrackNewComment.setNewComment;

  return pipe(comments, DE.squash(constant(defaultResult), flow(logQueryError, constant(defaultResult)), function (_ref2) {
    var _node$comments;

    var node = _ref2.node;
    return (_node$comments = node === null || node === void 0 ? void 0 : node.comments) !== null && _node$comments !== void 0 ? _node$comments : defaultResult;
  }), function (_ref3) {
    var edges = _ref3.edges,
        _ref3$pageInfo = _ref3.pageInfo,
        hasNextPage = _ref3$pageInfo.hasNextPage,
        endCursor = _ref3$pageInfo.endCursor;
    return {
      profileId: profile.id,
      publicResponseId: publicResponseId,
      comments: edges !== null && edges !== void 0 ? edges : [],
      hasNextPage: hasNextPage,
      totalCount: totalCount,
      handleHideComments: handleHideComments,
      newComment: newComment,
      handleFetchMoreComments: function handleFetchMoreComments() {
        return _handleFetchMoreComments(Str.isEmpty(endCursor) ? '0' : endCursor);
      },
      isLoading: DE.isPending(comments) || DE.isRefresh(comments),
      hiddenFromMembers: hiddenFromMembers
    };
  }, function (commentsListProps) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [useScrollToFocused ? /*#__PURE__*/_jsx(FocusedCommentsList, _objectSpread({
        useScrollToFocused: useScrollToFocused
      }, commentsListProps)) : /*#__PURE__*/_jsx(CommentsList, _objectSpread({}, commentsListProps)), !hiddenFromMembers && /*#__PURE__*/_jsx(UnavailableInLens, {
        tooltip: true,
        children: /*#__PURE__*/_jsx(ReplyInput, {
          replyInputRef: replyInputRef,
          profile: profile,
          publicResponseId: publicResponseId,
          totalFetched: commentsListProps.comments.length,
          onReplySuccess: setNewComment
        })
      })]
    });
  });
};

export default CommentsSection;